import { query, request } from '@/utils/request';

const urls = {
  syncBudgetInfo: '/zlb/budget/info/pull', // 同步预算指标
  budgetIndicatorsList: '/zlb/budget/info/list', // 预算指标列表
  // budgetIndicatorsList: '/zlb/budget/manage/page', // 单位预算指标
  budgetDetail: '/zlb/budget/info/detail', // 预算指标详情查询
  budgetUsedRecord: '/zlb/budget/manage/query-budget-used-record', // 预算日志
  departmentIndicatorsList: '/zlb/budget/info/query-budget',
};

export async function reqSyncBudgetInfo(params) {
  return request(`${urls.syncBudgetInfo}/${params?.orgId}`);
}

export async function fetchBudgetIndicatorsList(data) {
  return request(urls.budgetIndicatorsList, { method: 'POST', data });
}

export async function reqBudgetDetail(params) {
  return request(`${urls.budgetDetail}/${params.budgetId}`);
}

export async function getBudgetUsedRecord(data) {
  return request(urls.budgetUsedRecord, { method: 'POST', data });
}

export async function fetchDepartmentIndicatorsList(data) {
  return request(urls.departmentIndicatorsList, { method: 'POST', data });
}

// 列表导出预算指标
export async function exportIndicatorsList(data) {
  return query('/zlb/budget/info/export/submit', { method: 'POST', data });
}

// 获取导出结果
export async function getExportResult(params) {
  return query('/zlb/budget/info/export/result', { method: 'GET', params });
}

// 部门列表导出预算指标
export async function exportDeptIndicatorsList(data) {
  return query('/zlb/budget/info/export/dep/submit', { method: 'POST', data });
}

// 获取导出结果
export async function getExportDeptResult(params) {
  return query('/zlb/budget/info/export/dep/result', { method: 'GET', params });
}

// 预算指标导入实施金额
export async function importIndicatorSubmit(data) {
  return query('/zlb/budget/import/budget-implement-amount/submit', { method: 'POST', data });
}
